type IndicatorTypeType = 'PRICE' | 'OVERLAY' | 'OSCILLATOR'
const IndicatorType: Record<IndicatorTypeType, IndicatorTypeType> = {
  PRICE: 'PRICE',
  OVERLAY: 'OVERLAY',
  OSCILLATOR: 'OSCILLATOR',
}

type Indicator = {
  type?: (typeof IndicatorType)[keyof typeof IndicatorType]
  excludeSelfInRHS?: boolean
  value: string
  label: string
  nickname?: string
  fields: string[]
  params?: Record<string, any>
}

export default Indicator
export { IndicatorType }
